import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
    table: {
        width: '100%',
    },
    tableHead: {

        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#9e9e9e',
    },
    tableCell: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.6)',
    }
});

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}

const rows = [
    createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
    createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
    createData('Eclair', 262, 16.0, 24, 6.0),
    createData('Cupcake', 305, 3.7, 67, 4.3),
    createData('Gingerbread', 356, 16.0, 49, 3.9),
];

export default function SimpleTable({ data }) {
    const classes = useStyles();

    return (
        <TableContainer style={{ border: '1px solid #e5e5e5', borderRadius: '4px', borderBottom: 'none' }}>
            <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.tableHead}>Name</TableCell>
                        <TableCell className={classes.tableHead} align='center'>Email</TableCell>
                        <TableCell className={classes.tableHead} align='center'>Number of Sent Messages</TableCell>
                        <TableCell className={classes.tableHead} align='center'>Number of Sent Alamrs</TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, index) => (
                        <TableRow key={`${row.name}_${index}`}>
                            <TableCell component="th" scope="row">
                                {row.firstName + ' ' + row.lastName}
                            </TableCell>
                            <TableCell className={classes.tableCell} align="center">{row.email}</TableCell>
                            <TableCell className={classes.tableCell} align="center">{row.countMessage}</TableCell>
                            <TableCell className={classes.tableCell} align="center">{row.countAlarm}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}